import React from "react";
import Avatar from "@mui/material/Avatar";
import "./Card.css";
import CurrencyRupeeRoundedIcon from "@mui/icons-material/CurrencyRupeeRounded";
export default function AlreadyMemberCard({ state, onClick }) {
  React.useEffect(() => {
    if (state) {
        document.getElementById("alreadyMemberCard").classList.add("activateCard");
    } else {
        document.getElementById("alreadyMemberCard").classList.remove("activateCard");
    }
    return () => {
    };
  }, [state]);
  return (
    <div className="" onClick={onClick}>
      <div id="alreadyMemberCard" className="card col-md-12 col-12 ms-md-1">
        <div className="d-flex aligns-items-center justify-content-center">
          <Avatar sx={{ bgcolor: "gray" }}>
            <CurrencyRupeeRoundedIcon />
          </Avatar>
        </div>
        <p className="membership-type d-flex aligns-items-center justify-content-center text-center">
        Already Member
        </p>
        <div className="d-flex aligns-items-center justify-content-center">
          <i>0</i>
        </div>
      </div>
    </div>
  );
}